
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

import Mamber1 from "../images/client-1.webp";
import Mamber2 from "../images/client-2.webp";
import Mamber3 from "../images/client-3.webp";
import Mamber4 from "../images/client-4.webp";
import React, { useState, useEffect } from "react";
import { URL } from "../Redux/common/url";
const teamMembers = [
  { name: "Sapna Roy", designation: "Project Manager", img: Mamber1 },
  { name: "Michael Smith", designation: "Site Engineer", img: Mamber2 },
  { name: "Riya Malothera", designation: "Civil Engineer", img: Mamber3 },
  { name: "James Brown", designation: "Structural Engineer", img: Mamber4 },
  { name: "Sapna Roy", designation: "Project Manager", img: Mamber1 },
  { name: "Michael Smith", designation: "Site Engineer", img: Mamber2 },
  { name: "Riya Malothera", designation: "Civil Engineer", img: Mamber3 },
  { name: "James Brown", designation: "Structural Engineer", img: Mamber4 },
];

const TeamSlider = () => {
   const [productLists, setProductList] = useState([]);

  useEffect(() => {
    fetchProductList();
  }, []);

  const fetchProductList = async () => {
    try {
      const response = await fetch(
        `${URL.API_BASE_URL}/publicApi/teamListPublic`
      );
      if (response.ok) {
        const data = await response.json();
        console.log("API data:", data);
        setProductList(data?.team || []);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };
  return (
    <div className="container my-5">
      <h1 className="fw-bold text-center mb-4" style={{ color: '#079000'}}>
        Our Trusted Experts
      </h1>

      <Swiper
        modules={[Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 1000, disableOnInteraction: false }} // 1 sec auto slide
        breakpoints={{
          576: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
        }}
      >
         {(productLists.length > 0 ? productLists : teamMembers).map(
          (item, index) => (
          <SwiperSlide key={index} className="min-h-100">
            <div className="card shadow-sm text-center p-3 min-h-100">
              <img
                src={URL?.API_BASE_URL + item?.feature_image}
                  alt={item.feature_image}
                className="card-img-top mb-3"
              />
              <h5 className="fw-bold">{item.title}</h5>
              <p className="text-muted fw-bold">{item.short_description}</p>
            </div>
          </SwiperSlide>
      )
        )}
      </Swiper>
    </div>
  );
};

export default TeamSlider;
